{
  "actions": {
    "title": "Neue Produkte",
    "devices": "Neue Geräte",
    "applications": "Neue Anwendungen"
  },
  "services": {
    "title": "Dienstaktivierung",
    "activeDirectory": "Active Directory",
    "pkiConnector": "PKI-Konnektor",
    "smtpServer": "SMTP-Server",
    "unauthorized": "Keine Informationen zur Dienstaktivierung verfügbar"
  },
  "sector": {
    "title": "Meine Sektoren",
    "devices": "Geräte",
    "applications": "Anwendungen"
  },
  "certificates": {
    "valid": "Gültige Zertifikate",
    "certificate": "Zertifikate",
    "device": "S4-Zertifikate",
    "manager": "S4-Manager-Zertifikate",
    "tools": "S4-Tools-Zertifikate",
    "view": "S4-Zertifikate anzeigen",
    "legend": {
      "valid": "Gültig",
      "expireSoon": "Gültigkeit < 1 Monat",
      "expired": "abgelaufen"
    },
    "noData": "Keine Daten",
    "title": "Zertifikatsstatus",
    "expired": "Abgelaufen",
    "lessThanOneMonth": "Weniger als 1 Monat",
    "lessThanThreeMonths": "Weniger als 3 Monate",
    "lessThanSixMonths": "Weniger als 6 Monate",
    "moreThanSixMonths": "Mehr als 6 Monate"
  },
  "firmwares": {
    "noData": "Keine Daten",
    "others": "Andere",
    "title": "Firmware-Versionsverteilung",
    "unknown": "Unbekannt"
  },
  "deviceStates": {
    "title": "Gerätestatus",
    "states": {
      "activated": "Aktiviert",
      "disabled": "Deaktiviert",
      "preprovisioned": "Vorab bereitgestellt",
      "registered": "Registriert",
      "locked": "Gesperrt"
    }
  },
  "connectivity": {
    "title": "Verbindungsstatus",
    "states": {
      "lessThan": "Weniger als {duration}",
      "moreThan": "Mehr als {duration}",
      "unknown": "Noch keine Abfrage"
    },
    "noData": "Keine Daten"
  }
}
